import React from 'react';

export const CopilotLineGraphBackgroundLayer = (props: any) => {
  const width = props.width;
  const height = props.height;
  const { left } = props.margin;
  const xPositions = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map(
    (value) => {
      // 105 is the max value of the x axis
      return (value / 105) * (width - left);
    },
  );
  return (
    <g>
      <path d="M -30 -20 H 875 V 471 H -30" fill="#000B1C" />
      <path
        d="M -30 -20 H 875 V 471 H -30"
        fill="url(#chartGradient)"
        fillOpacity="0.2"
      />
      <g>
        {xPositions.map((xPosition, key) => {
          return (
            <rect
              key={key}
              x={xPosition}
              y={0}
              width={1}
              height={height}
              fill="#04407C"
            />
          );
        })}
      </g>

      <radialGradient
        id="chartGradient"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(860.513 8.4215) rotate(151.935) scale(975.176 2700.27)"
      >
        <stop stopColor="#933EE5" />
        <stop offset="1" stopColor="#933EE5" stopOpacity="0" />
      </radialGradient>
    </g>
  );
};
